import {useState} from 'react';
import {loadSession,type LocalSession} from '../lib/queue.ts';
import {waitingRows} from '../lib/prune.ts';
import {supabase} from '../lib/supabase.ts';

export default function SavedUploads({sessions,unverifiedOwners,uploading,onRetry}:{
  sessions:LocalSession[];unverifiedOwners:number;uploading:boolean;onRetry:()=>void;
}) {
  const [error,setError]=useState<string|null>(null);
  async function download(session:LocalSession) {
    try {
      const current=await loadSession(session.id);
      const actor=(await supabase.auth.getSession()).data.session?.user.id;
      if(!current || !actor || current.observerId!==actor)throw new Error('Sign in with the account that recorded this session to download it.');
      const body={format:'field-observation-recovery-v1',savedAt:Date.now(),
        notice:'Local saved records for recovery. This copy does not confirm upload or change the server record.',session:current};
      const url=URL.createObjectURL(new Blob([JSON.stringify(body,null,2)],{type:'application/json'}));
      const a=document.createElement('a');a.href=url;a.download=`saved-session-${current.id}.json`;a.click();
      setTimeout(()=>URL.revokeObjectURL(url),30_000);setError(null);
    } catch(e) {setError(e instanceof Error?e.message:String(e));}
  }
  return <section className="card saved-uploads">
    <h3>Saved uploads</h3>
    <p>These records are still on this browser. Keep the same account signed in with signal. If a problem persists, download the saved records and ask an admin for help before clearing browser data.</p>
    <button disabled={uploading} onClick={onRetry}>{uploading?'Retrying saved uploads…':'Retry saved uploads'}</button>
    {unverifiedOwners>0 && <p className="err">Some older saved records could not be matched to this sign-in. Sign in with the account that started them, or ask an admin for help. They remain stored here; their upload status is unverified.</p>}
    {sessions.map(s=><div key={s.id} data-saved-session={s.id}>
      <h4>{s.venueName??'Saved session'} · {new Date(s.startedAt).toLocaleString()}</h4>
      <p>Session {s.id}</p>
      <p>{waitingRows(s)} recorded rows awaiting upload{s.endedAt!==null&&!s.endSyncedAt?' · Session end not confirmed':''}{s.startPending?' · Finish starting this session above':''}.</p>
      {s.lastAttemptAt && <p className="muted">Last upload attempt: {new Date(s.lastAttemptAt).toLocaleString()}</p>}
      {s.lastError && <p className="err">{s.lastError}</p>}
      <button onClick={()=>void download(s)}>Download saved records</button>
    </div>)}
    {error&&<p role="alert" className="err">{error}</p>}
  </section>;
}
